// DS: i4.35
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const CommissionBrush: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m14.765 9.974-1.4-1.304c-1.374-2.448 1.652-5.7 6.07-4.434.236.067.284.372.087.517-.418.308-.912.925-.972 2.135-.118 2.432-1.81 4.26-3.785 3.086ZM13.523 10.636c.746.75.778 2.38.072 3.083-2.45 1.93-8.073 6.35-8.068 6.348l-.005.002c-.291.14-.752 0-1.11-.359-.341-.341-.484-.775-.377-1.067 0 0 4.795-6.072 6.405-8.095.706-.702 2.336-.662 3.083.088Z" />
    </svg>
  </IconWrap>
);
CommissionBrush.displayName = 'CommissionBrush';

export default CommissionBrush;
